module.exports = __webpack_public_path__ + "static/images/monet/lat_long_field.svg";